import React, { useState } from 'react';
import './App.css';
import SEO from './components/SEO';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Gallery from './components/Gallery';
import Stats from './components/Stats';
import Programs from './components/Programs';
import Achievements from './components/Achievements';
import Testimonials from './components/Testimonials';
import Branches from './components/Branches';
import CareerCompass from './components/CareerCompass';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';
import WhatsAppFloat from './components/WhatsAppFloat';

function App() {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <div className="App">
      <SEO />
      <Navbar onEnrollClick={handleOpenModal} />
      <Hero onEnrollClick={handleOpenModal} />
      <About />
      <Gallery />
      <Stats />
      <Programs />
      <Achievements />
      <Testimonials />
      <Branches />
      <CareerCompass />
      <Footer onEnrollClick={handleOpenModal} />
      <ContactModal show={showModal} onClose={handleCloseModal} />
      <WhatsAppFloat onClick={handleOpenModal} />
    </div>
  );
}

export default App;
